import BigNumber from 'bignumber.js';

/**
 * Formats a BigNumber to a short string with appropriate units.
 * For example, 305552748.47 becomes '305.5m'.
 *
 * @param value - The BigNumber value to format.
 * @param decimalPlaces - Number of decimal places to include.
 * @returns A formatted string with units.
 */
export function formatBigNumberShort(
  value: BigNumber,
  decimalPlaces: number = 1,
): string {
  const million = new BigNumber(1_000_000);
  const billion = new BigNumber(1_000_000_000);

  if (value.isGreaterThanOrEqualTo(billion)) {
    return `${value.dividedBy(billion).toFixed(decimalPlaces)}b`;
  } else if (value.isGreaterThanOrEqualTo(million)) {
    return `${value.dividedBy(million).toFixed(decimalPlaces)}m`;
  } else {
    return value.decimalPlaces(decimalPlaces).toFormat();
  }
}
